/**
 * What the board shows about the `claude` account under the topbar: its plan
 * usage, and the "need Claude" entries coming up on any of the reader's teams.
 * Module-level, like lib/gitPushes.ts: the socket lives in the board store,
 * which only pokes `claudeCalendarChanged()`; the strip does the fetching.
 */
import { ref } from "vue";

/** Bumped by the board store on any availability event and on a resync. */
export const claudeCalendarGen = ref(0);

export function claudeCalendarChanged(): void {
  claudeCalendarGen.value++;
}
